import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "../../types/user.type";

type UserState = User | null;

// TODO: временный initialState для разработки, заменить на null и загрузку с бэкенда
const initialState = null as UserState;

export const userSlice = createSlice({
	name: "user",
	initialState,
	reducers: {
		setUserData(_state, action: PayloadAction<User | null>) {
			return action.payload;
		},
	},
});

export const { setUserData } = userSlice.actions;
export default userSlice.reducer;
